module.exports = __webpack_public_path__ + "static/media/light-switch-on.5f51d7e7.svg";